enum MapType {
  Leaflet = 'leaflet',
  Google = 'google',
}

export default MapType;
